<template>
  <v-navigation-drawer v-model="dataFlag" :clipped="$vuetify.breakpoint.lgAndUp" :width="500" fixed right
    @input="setFlag">
    <v-toolbar dark :color="this.$gf.headerColor()">
      <v-toolbar-title>Update Company Banding</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab small @click="closeDrawer" :color="this.$gf.headerColor()">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-row align-center justify-center>
      <v-col md="12">
        <div>
          <v-card-text>
            <v-select :items="bandingOptions" v-model="currentBanding" item-value="id" item-text="name"
              label="Company Banding" filled return-object @change="onBandingOptionChange"></v-select>
            <!-- Loading Spinner -->
            <div v-if="loadingPackages" class="d-flex align-center mt-4">
              <v-progress-circular indeterminate color="primary" class="mr-2"></v-progress-circular>
              <span>Loading packages...</span>
            </div>
            <!-- Conditionally Show Second Dropdown -->
            <v-select v-if="packageOptions.length > 0" v-model="selectedPackage" :items="packageOptions" item-value="id"
              :item-text="formatPackageLabel" label="Select Package" class="mt-4" return-object
              @change="onPackageOptionChange"></v-select>
          </v-card-text>
        </div>
      </v-col>
    </v-row>

    <v-row align-center justify-center class="scroll-y mb-5">
      <v-col md="12">
        <div>
          <v-card-text>
            <p class="font-weight-bold text-center mb-2" v-if="maxCourse"> You can select up to {{ this.maxCourse }}
              courses.</p>
            <div style="border:1px solid rgba(0, 0, 0, 0.12); margin-bottom: 50px;" v-if="maxCourse">
              <div class="filterSection">
                <v-text-field v-model="search" label="Search Courses" placeholder="Search Courses" type="text"
                  @change="applyCourseSearch" append-icon="fa-search" class="filter-user"></v-text-field>
                <v-select :items="categories" :clearable="true" item-text="name" item-value="id" ref="categoryFilterBox"
                  placeholder="Filter course categories" multiple small-chips class="categories"
                  v-model="selectedCategory" v-on:change="filterCoursesByCategories($event)"
                  menu-props="content-class: dropdown-below" @click:clear="handleClear">
                  <template v-slot:prepend-item>
                    <v-list-item ripple @click="toggleSelectAll">
                      <v-list-item-action>
                        <v-checkbox :input-value="selectAll" />
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>Select All</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                  </template>
                  <template v-slot:selection="{ item, index }">
                    <template v-if="index < 2">
                      <v-chip :title="item.name">{{ $gf.truncateText(item.name, 6) }}</v-chip>
                    </template>
                    <template v-if="index === 2">
                      <v-chip>...</v-chip>
                    </template>
                  </template>
                </v-select>
              </div>
              <v-divider></v-divider>
              <v-expansion-panels accordion v-model="panel" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header expand-icon="mdi-menu-down" color="grey50"
                    class="assigned-user-heading assigned-user-heading2">
                    Default Courses
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="ml-1" text x-small color="$improve-grey-900" style="width:auto;">
                          <v-icon x-small>fa fa-question</v-icon>
                        </v-btn>
                      </template>
                      <span>Removing any preselected course will delete all associated data for users who have that
                        course
                        assigned.</span>
                    </v-tooltip>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-skeleton-loader v-if="loading && isTabletOrDesktop" type="table"
                      :types="{ 'table-heading': '', 'table-thead': 'heading@4', 'table-row': 'text@2' }"
                      class="slider-table"></v-skeleton-loader>
                    <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table"
                      :types="{ 'table-heading': '', 'table-thead': 'heading@1', 'table-row': 'text@1' }"
                      class="slider-table"></v-skeleton-loader>
                    <v-data-table v-model="selected" :headers="headers"
                      v-show="!loading" :items="courses" show-select
                      item-key="id" class="mb-5 enrol-user-list-tbl" :footer-props="{
                        'items-per-page-options': [5, 10, 15, -1]
                      }" @toggle-select-all="selectAllToggle" @input="handleSelection"
                      @update:items-per-page="onItemsPerPageChange">

                    </v-data-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </v-card-text>
        </div>
      </v-col>
    </v-row>
    <v-footer absolute height="68">
      <v-flex  text-right>
        <div>
          <v-btn v-if="loading" color="primary" loading></v-btn>
          <v-btn v-else color="primary" @click="updateCompanyBanding" :disabled="updateBandingButtonDisabled">Update
            Banding</v-btn>
        </div>
      </v-flex>
    </v-footer>
  </v-navigation-drawer>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import companyAPI from '@/api/company.js';
import courseAPI from "@/api/course.js";
export default {
  name: 'companyBandingDrawer',
  components: {},
  props: {
    companyBandingDrawer: {
      type: Boolean,
      default: false,
    },
    banding: {
      type: Object,
      default: null
    },
    package: {
      type: [Array, Object],
      default: null
    },
    courseNamesToSelect: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      dataFlag: false,
      bandingOptions: [],
      loading: false,
      currentBanding: 1,
      loadingPackages: false,
      packageOptions: [],
      selectCoursesButton: false,
      categories: [],
      selectedCategory: [],
      headers: [
        { text: "Course", value: "name" }
      ],
      serverItemsLength: 0,
      courses: [],
      selected: [],
      search: "",
      searchParams: "",
      maxCourse: 0,
      itemsPerPage: 10,
      maxSelected: false,
      selectedPackage: null,
      updateBandingButtonDisabled: false,
      panel: [0, 1],
      availableCoursesSelected: false,
      totalAvailableCourse: 0,
      courseNames: [],
      removed: [],
      firstTime: false
    };
  },
  computed: {
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
    selectAll() {
      return this.selectedCategory.length === this.categories.length;
    },
    selectedArray: function () {
      let selectedCourses = [];
      this.selected.map(x => {
        selectedCourses.push(x.id);
      });
      return selectedCourses;
    },
  },
  mounted() {
    this.getBandings();
  },
  methods: {
    setFlag() {
      EventBus.$emit('COMPANYBANDING_DRAWER_STATE', this.dataFlag);
    },
    closeDrawer() {
      EventBus.$emit('COMPANYBANDING_DRAWER_STATE', false);
    },
    getBandings() {
      this.loading = true;
      companyAPI
        .getAllBandings()
        .then((res) => {
          this.loading = false;
          this.bandingOptions = Object.values(res.data.banding);
        });
    },
    updateCompanyBanding() {
      const packageId = typeof this.selectedPackage === 'object' && this.selectedPackage !== null ? this.selectedPackage.id : '';
      const maxCourse = typeof this.selectedPackage === 'object' && this.selectedPackage !== null ? this.selectedPackage.max : 'All';
      const modules = this.selectedArray;
      const unselectedCourseNames = this.removed;
      if(packageId > 1 && (modules.length < this.maxCourse)){
          this.$snotify.warning("A minimum of " + this.maxCourse + " courses must be selected as per the package limit.");
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
         return;   
       }
      if(packageId > 1 && (modules.length > this.maxCourse)){
        this.$snotify.warning("Only " + this.maxCourse + " courses are selectable due to the package limit.");
          setTimeout(() => {
            this.$gf.removeBackdrop();
            this.maxSelected = false;
          }, 300);
          return;
      }
      this.loading = true;
      companyAPI
        .upgradeAccount(this.$route.params.id, this.currentBanding, packageId, modules, unselectedCourseNames, maxCourse)
        .then(response => {
          this.loading = false;
          if (response.data.status == 'updated') {
            EventBus.$emit('COMPANY_BANDING_UPDATED', true, response.data.message);
            this.closeDrawer();
          } else {
            EventBus.$emit('COMPANY_BANDING_UPDATED', false, response.data.message);
          }
          EventBus.$emit('reload');
        }).catch(error => {
          this.loading = false;
          EventBus.$emit('COMPANY_BANDING_UPDATED', false, error.response.data.message);
        });
    },
    onBandingOptionChange(option) {
      if(this.$globalConfig.APP_NAME == 'partner'){
      this.selected = [];
      this.packageOptions = [];
      this.selectedPackage = null;
      this.selectCoursesButton = false;
      this.maxCourse = 0;
        this.updateBandingButtonDisabled = true;
        this.loadingPackages = true;
        companyAPI.getPartnerBandingPackages(option.id).then((res) => {
          this.loadingPackages = false;
          const packageLists = Object.values(res.data.package);
          this.packageOptions = packageLists.length > 1 ? Object.values(res.data.package) : [];
          if(this.packageOptions.length == 0){
            this.updateBandingButtonDisabled = false;
          }
        });
      }
    },
    onPackageOptionChange(option) {
      this.maxCourse = 0;
      this.updateBandingButtonDisabled = false;
      if (option.max != null) {
        this.maxCourse = option.max;
      }else{
        this.addCustomerButtonDisabled = false;
      }
      if (!this.categories.length){
        this.getAllCourseCategories();
        this.getAllDefaultCourses();
      }
    },
    getAllDefaultCourses() {
      this.loading = true;
      courseAPI.getDefaultCourse(this.searchParams).then(response => {
        this.loading = false;
        this.courses = response.data.data;

        this.selectAvailableCompanyCourses();
      });
    },
    applyCourseSearch() {
      this.searchParams = '';

      this.searchParams = this.search && this.search.length > 0
        ? '?search=name:' + this.search : '';

      if (this.selectedCategory.length) {
        this.searchParams += this.searchParams == '' ?  
        '?categories=' + this.selectedCategory.toString()
        : '&categories=' + this.selectedCategory.toString();
      } 

      this.getAllDefaultCourses();
    },
    getAllCourseCategories() {
      courseAPI.getAllCourseCategories().then(response => {
        this.categories = response.data.data;
      });
    },
    filterCoursesByCategories() {
      this.applyCourseSearch();
    },
    handleClear() {
      const dropdown = this.$refs.categoryFilterBox.$el;
      dropdown.style.removeProperty("overflow");
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedCategory = [];
      } else {
        this.selectedCategory = this.categories.map((cat) => cat.id);
      }

      this.applyCourseSearch()
    },
    selectAllToggle({ value, items }) {
      const pageItemObjects = this.courses; // current page's rows (full objects)

      if (value) {

        if (this.selected.length >= this.maxCourse) {
          this.maxSelected = true;
          this.$snotify.warning("Only " + this.maxCourse + " courses are selectable due to the package limit.");
          setTimeout(() => {
            this.$gf.removeBackdrop();
            this.maxSelected = false;
          }, 300);
          return;
        }
        const remaining = this.maxCourse - this.selected.length;

        const selectedIds = items.slice(0, remaining);

        this.selected = [...this.selected, ...selectedIds];
      } else {
        // const removed = this.itemsPerPage;
        // this.selected = this.selected.slice(0, removed);
        const pageIds = pageItemObjects.map(item => item.id);

        this.selected = this.selected.filter(item => !pageIds.includes(item.id));
      }
    },
    handleSelection(newSelection) {
      // If over the allowed course limit
      if (newSelection.length > this.maxCourse) {
        this.$nextTick(() => {
          this.selected = newSelection.slice(0, this.maxCourse);          
        });

        if(this.courseNames.length == this.maxCourse && this.firstTime){
            this.maxSelected = true;
              setTimeout(() => {
               this.maxSelected = false;
               this.firstTime = false;
            }, 300);
        }

        if (!this.maxSelected) {
          this.maxSelected = true;
          this.$snotify.warning(
            "Only " + this.maxCourse + " courses are selectable due to the package limit."
          );
          setTimeout(() => {
             this.$gf.removeBackdrop();// Optional chaining
            this.maxSelected = false;
          }, 300);
        }

        return; // Prevent processing courseNames if over limit
      }

      // Update selected items
      this.selected = newSelection;

      // --- Course name tracking ---
      const prev = this.lastSelectedRows || [];
      const curr = newSelection;

      const prevIds = new Set(prev.map(item => item.id));
      const currIds = new Set(curr.map(item => item.id));

      // Added rows
      const added = curr.filter(item => !prevIds.has(item.id));
      added.forEach(item => {
        if (!this.courseNames.includes(item.name)) {
          this.courseNames.push(item.name);
          let index = this.removed.indexOf(item.name);
            if (index !== -1) {
              this.removed.splice(index, 1);
            }
        }
      });

      // Removed rows
      const removedCourse = prev.filter(item => !currIds.has(item.id));
      removedCourse.forEach(item => {
        this.courseNames = this.courseNames.filter(name => name !== item.name);
        if (!this.courseNames.includes(item.name)) {
          this.removed.push(item.name);
          }
      });

      // Store for next comparison
      this.lastSelectedRows = [...curr];
  },
  onItemsPerPageChange(value) {
    this.itemsPerPage = value;
  },
  selectAvailableCompanyCourses() {
    this.firstTime = true;
    if (this.courses.length && this.courseNames.length && !this.availableCoursesSelected) {

      const matchedCourses = this.courses.filter(item =>
        this.courseNames.includes(item.name)
      );

      this.selected = [
        ...this.selected,
        ...matchedCourses.filter(
          course => !this.selected.some(sel => sel.id === course.id)
        )
      ];

    }
  },
  formatPackageLabel(item) {
      if (!item) return '';
      // Add your custom logic here
      return `${item.name}  ${item.max ? ' (Max Courses: ' + item.max + ')': ''}`;
  },
},
watch: {
  companyBandingDrawer: {
    handler(value) {
      this.dataFlag = value;
    },
    deep: true,
    },
  banding: {
    handler(value) {
      this.currentBanding = value;
      this.onBandingOptionChange(this.currentBanding)
    },
    deep: true,
    },
  package: {
    handler(value) {
      this.selectedPackage = value;
      this.onPackageOptionChange(this.selectedPackage)
    },
    deep: true,
    },
  courseNamesToSelect: {
     handler() {
      this.courseNames = [...this.courseNamesToSelect];
    },
    deep: true
  }
}
};
</script>
<style scoped>
.v-navigation-drawer {
  min-height: 400px !important;
}
</style>
